export default "__VITE_ASSET__def8ec7b__"